import { addMinutes, parseISO } from 'date-fns';
import { Availability } from '../types/availability';

export function setEventDates(data: Availability) {
  const { slots, duration, time_zone } = data;

  if (!slots || slots.length === 0) {
    return { startDate: null, endDate: null };
  }

  let availableSlot = null;
  let lastSlot = null;

  // Loop through all slots to find available ones or at least the last one
  for (const slotDay of slots) {
    const { hours } = slotDay;

    if (!hours || hours.length === 0) continue;

    // Update the last slot in any case
    lastSlot = hours[hours.length - 1];

    // Find the first available slot
    const available = hours.find((hour) => hour.available > 0);
    if (available) {
      availableSlot = available;
      break;
    }
  }

  // Use the available slot if found, otherwise use the last slot
  const selectedSlot = availableSlot || lastSlot;

  // If no slot was found at all, return null dates
  if (!selectedSlot) {
    return { startDate: null, endDate: null };
  }

  // Parse the time string to a Date object
  const startDate = parseISO(selectedSlot.time);

  // Calculate endDate by adding duration minutes to startDate
  const endDate = addMinutes(startDate, duration!);

  return {
    start_at: startDate,
    end_at: endDate,
    duration,
    time_zone,
    available: availableSlot?.available,
  };
}
